module.exports = __webpack_public_path__ + "static/media/fill_orange_32.6ab47dea.svg";